<template>
  <ok-modal
    :value="value"
    size="md"
    :no-close-on-backdrop="submitting"
    :title="$t('subscription.sorry-to-go')"
    @change="submitting ? null : $emit('input', $event)"
  >
    <error-alert :error="error" />

    <div class="text-secondary font-weight-semi-bold">

      <div class="text-normal">
        <p>
          {{ $t('subscription.subscription-cancel-description', [expiresAt]) }}
        </p>
        <ul>
          <li
            v-for="(feature, featureIdx) in freePackageFeatures"
            :key="featureIdx"
          >
            {{ feature.text }}
          </li>
        </ul>

      </div>

      <div class="description-text mb-1">
        {{ $t('subscription.subscription-cancel-contact') }}
        <a
          :href="`mailto:${CONTACT_EMAIL}`"
          target="_blank"
          class="font-weight-bold"
        >
          {{ CONTACT_EMAIL }}
        </a>
      </div>

      <div class="description-text mb-1">
        {{ $t('subscription.no-refund-on-cancel') }}
      </div>

      <div class="d-flex justify-content-between align-items-center">
        <div class="text-small">
          {{ $t('subscription.check-latest-offers') }}
        </div>

        <div class="d-flex align-items-center">

          <div
            class="text-danger text-small cursor-pointer text-small pr-1"
            @click="confirm"
          >
            <b-spinner
              v-if="submitting"
              small
            />
            <template v-else>
              {{ $t('subscription.cancel-my-subscription') }}
            </template>
          </div>

          <b-button
            variant="secondary"
            :disabled="submitting"
            @click="$emit('input', false)"
          >
            {{ $t('subscription.dismiss') }}
          </b-button>
        </div>
      </div>
    </div>
  </ok-modal>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import OkModal from '@/@okmenu/components/modals/OkModal'
import { CONTACT_EMAIL } from '@/constants/config'
import SubscriptionAPIs from '@/API/subscription/subscription-api'
import ErrorAlert from '@/@okmenu/components/alerts/ErrorAlert'
import PricingMixin from '@/mixins/pricing-mixin'

export default {
  name: 'CancelSubscriptionModal',
  components: {
    ErrorAlert, BButton, BSpinner, OkModal,
  },
  mixins: [PricingMixin],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CONTACT_EMAIL,
      submitting: false,
      error: null,
    }
  },
  computed: {
    ...mapGetters({
      expiresAt: 'subscription/expiresAt',
      freePackage: 'pricing/freePackage',
    }),
    freePackageFeatures() {
      return this.getPackageBenefits(this.freePackage)
    },
  },
  methods: {
    async confirm() {
      this.submitting = true
      this.error = false

      try {
        const response = await SubscriptionAPIs.subscribeFree()
        await this.$store.dispatch('auth/FETCH_USER_INFO')

        if (this.$store.getters['pricing/pricesFetched']) {
          this.$store.dispatch('pricing/FETCH_PRICING', true).catch(error => console.error(error))
        }

        this.$notifySuccess(response.message)
        this.$emit('input', false)
      } catch (e) {
        this.error = e
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>
